// The advertiser coupon badge ("25% OFF") on .fans sponsor cards (Nicky,
// 27 Oct 2026): a quiet neutral chip instead of the old bright red, at the
// card's bottom-right corner. It straddles the card's edge, so half of it sits
// on the page background: a solid fill keeps the text readable on any page,
// and each pair clears 4.5:1 (see adCouponBadge.test.ts).

export type CouponBadgeColors = { background: string; color: string; borderColor: string };

/** Light pages (near-opaque light card). */
export const COUPON_BADGE_LIGHT: CouponBadgeColors = {
  background: '#f3f4f6', // gray-100
  color: '#374151', // gray-700
  borderColor: 'rgba(0, 0, 0, 0.10)',
};

/** Dark pages (translucent card, white text). */
export const COUPON_BADGE_DARK: CouponBadgeColors = {
  background: '#1f2937', // gray-800
  color: '#e5e7eb', // gray-200
  borderColor: 'rgba(255, 255, 255, 0.15)',
};

export const couponBadgeColors = (pageIsLight: boolean): CouponBadgeColors =>
  pageIsLight ? COUPON_BADGE_LIGHT : COUPON_BADGE_DARK;
